import { frodoMediaArray } from './frodoMedia'
import { frodoBio } from './frodoBios'

import { hollyReviewerReviewHinge, luigiReviewerReviewBumble, gatsbyReviewerReviewTinder } from './frodoReviewerReviews'
import { hollyReviewerProfile, luigiReviewerProfile, gatsbyReviewerProfile } from './frodoReviewers'

export const hollyProfileReviewHinge = {
  _id: 'hollyProfileReviewHingeId',
  userId: 'frodoUserId',
  userEmail: 'frodo@email.com',
  datingProfileId: 'frodoDatingProfileHingeId',
  reviewerProfileId: 'hollyReviewerProfileId',
  reviewerEmail: 'holly@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: frodoMediaArray[7]._id,
      mediaItemURL: frodoMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[7].type,
      caption: frodoMediaArray[7].captions[0],
      subcaption: frodoMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[0]._id,
      mediaItemURL: frodoMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[0].type,
      caption: frodoMediaArray[0].captions[0],
      subcaption: frodoMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[1]._id,
      mediaItemURL: frodoMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[1].type,
      caption: frodoMediaArray[1].captions[0],
      subcaption: frodoMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[3]._id,
      mediaItemURL: frodoMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[3].type,
      caption: frodoMediaArray[3].captions[0],
      subcaption: frodoMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[4]._id,
      mediaItemURL: frodoMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[4].type,
      caption: frodoMediaArray[4].captions[0],
      subcaption: frodoMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[13]._id,
      mediaItemURL: frodoMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[13].type,
      caption: frodoMediaArray[13].captions[0],
      subcaption: frodoMediaArray[13].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! It showcases your eyes, hair, and soft features`,
      verdict: 'Very',
    },
    {
      feedback: `Love the candid hiking shot with your friend`,
      verdict: 'Yes',
    },
    {
      feedback: `A moodier vibe si something I find nice, but will it attract grass-loving, idle-minded hobbits?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `You look good here, but it's a bit menacing, I'm not sure you want to be holding a sword in such a threatening way on a dating app`,
      verdict: 'No',
    },
    {
      feedback: `You look super affable and like a total gentleman-hobbit`,
      verdict: 'Very',
    },
    {
      feedback: `Another intense photo. I find it cool, but don't hobbits prefer idleness?`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: frodoBio._id,
    vitalInfo: { ...frodoBio.vitalInfo },
    prompts: [
      { ...frodoBio.prompts[0] },
      { ...frodoBio.prompts[1] },
      { ...frodoBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Pretty standard... nothing really stands out as great or not great`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Nobody is going to get this, and it sounds very intense — too intense for a hobbit`,
        verdict: 'No', 
      },
      {
        feedback: `This is good to show that even though I'm adventurous I like to idle about`,
        verdict: 'Yes', 
      },
      {
        feedback: `It's OK`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Frodo is handsome and looks to be a gentleman, and he's quite adventurous, especially for a hobbit`,
    good: `You're very handsome and seem like a gentleman`,
    notGood: `The adventurousness and intensity. Remember, you're trying to attract hobbits, who prefer idleness`,
    verdict: `Overall it's a good start. Just add a bit more levity to your profile, and someone as handsome as you are will be swimming in matches`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...hollyReviewerReviewHinge },
  reviewerProfile: { ...hollyReviewerProfile },
  bioItems: { ...frodoBio },
  mediaItems: [ ...frodoMediaArray ],
}

export const luigiProfileReviewBumble = {
  _id: 'luigiProfileReviewBumbleId',
  userId: 'frodoUserId',
  userEmail: 'frodo@email.com',
  datingProfileId: 'frodoDatingProfileBumbleId',
  reviewerProfileId: 'luigiReviewerProfileId',
  reviewerEmail: 'luigi@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: frodoMediaArray[7]._id,
      mediaItemURL: frodoMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[7].type,
      caption: frodoMediaArray[7].captions[0],
      subcaption: frodoMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[0]._id,
      mediaItemURL: frodoMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[0].type,
      caption: frodoMediaArray[0].captions[0],
      subcaption: frodoMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[1]._id,
      mediaItemURL: frodoMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[1].type,
      caption: frodoMediaArray[1].captions[0],
      subcaption: frodoMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[3]._id,
      mediaItemURL: frodoMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[3].type,
      caption: frodoMediaArray[3].captions[0],
      subcaption: frodoMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[4]._id,
      mediaItemURL: frodoMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[4].type,
      caption: frodoMediaArray[4].captions[0],
      subcaption: frodoMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[13]._id,
      mediaItemURL: frodoMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[13].type,
      caption: frodoMediaArray[13].captions[0],
      subcaption: frodoMediaArray[13].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! It showcases your eyes, hair, and soft features`,
      verdict: 'Very',
    },
    {
      feedback: `Love the candid hiking shot with your friend`,
      verdict: 'Yes',
    },
    {
      feedback: `A moodier vibe si something I find nice, but will it attract grass-loving, idle-minded hobbits?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `You look good here, but it's a bit menacing, I'm not sure you want to be holding a sword in such a threatening way on a dating app`,
      verdict: 'No',
    },
    {
      feedback: `You look super affable and like a total gentleman-hobbit`,
      verdict: 'Very',
    },
    {
      feedback: `Another intense photo. I find it cool, but don't hobbits prefer idleness?`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: frodoBio._id,
    vitalInfo: { ...frodoBio.vitalInfo },
    prompts: [
      { ...frodoBio.prompts[0] },
      { ...frodoBio.prompts[1] },
      { ...frodoBio.prompts[2] }
    ],
    aboutMe: frodoBio.aboutMe[0],
    hobbies: [frodoBio.hobbies[0], frodoBio.hobbies[1], frodoBio.hobbies[2], frodoBio.hobbies[3], frodoBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Pretty standard... nothing really stands out as great or not great`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'This is good! Let them know you prefer the idle life to the adventure you encountered',
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Nobody is going to get this, and it sounds very intense — too intense for a hobbit`,
        verdict: 'No', 
      },
      {
        feedback: `This is good to show that even though I'm adventurous I like to idle about`,
        verdict: 'Yes', 
      },
      {
        feedback: `It's OK`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Frodo is handsome and looks to be a gentleman, and he's quite adventurous, especially for a hobbit`,
    good: `You're very handsome and seem like a gentleman`,
    notGood: `The adventurousness and intensity. Remember, you're trying to attract hobbits, who prefer idleness`,
    verdict: `Overall it's a good start. Just add a bit more levity to your profile, and someone as handsome as you are will be swimming in matches`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...luigiReviewerReviewBumble },
  reviewerProfile: { ...luigiReviewerProfile },
  bioItems: { ...frodoBio },
  mediaItems: [ ...frodoMediaArray ],
}

export const gatsbyProfileReviewTinder = {
  _id: 'gatsbyProfileReviewTinderId',
  userId: 'frodoUserId',
  userEmail: 'frodo@email.com',
  datingProfileId: 'frodoDatingProfileTinderId',
  reviewerProfileId: 'gatsbyReviewerProfileId',
  reviewerEmail: 'gatsby@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: frodoMediaArray[7]._id,
      mediaItemURL: frodoMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[7].type,
      caption: frodoMediaArray[7].captions[0],
      subcaption: frodoMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[0]._id,
      mediaItemURL: frodoMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[0].type,
      caption: frodoMediaArray[0].captions[0],
      subcaption: frodoMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[1]._id,
      mediaItemURL: frodoMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[1].type,
      caption: frodoMediaArray[1].captions[0],
      subcaption: frodoMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[3]._id,
      mediaItemURL: frodoMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[3].type,
      caption: frodoMediaArray[3].captions[0],
      subcaption: frodoMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[4]._id,
      mediaItemURL: frodoMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[4].type,
      caption: frodoMediaArray[4].captions[0],
      subcaption: frodoMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[13]._id,
      mediaItemURL: frodoMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[13].type,
      caption: frodoMediaArray[13].captions[0],
      subcaption: frodoMediaArray[13].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! It showcases your eyes, hair, and soft features`,
      verdict: 'Very',
    },
    {
      feedback: `Love the candid hiking shot with your friend`,
      verdict: 'Yes',
    },
    {
      feedback: `A moodier vibe si something I find nice, but will it attract grass-loving, idle-minded hobbits?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `You look good here, but it's a bit menacing, I'm not sure you want to be holding a sword in such a threatening way on a dating app`,
      verdict: 'No',
    },
    {
      feedback: `You look super affable and like a total gentleman-hobbit`,
      verdict: 'Very',
    },
    {
      feedback: `Another intense photo. I find it cool, but don't hobbits prefer idleness?`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: frodoBio._id,
    vitalInfo: { ...frodoBio.vitalInfo },
    prompts: [
      { ...frodoBio.prompts[0] },
      { ...frodoBio.prompts[1] },
      { ...frodoBio.prompts[2] }
    ],
    aboutMe: frodoBio.aboutMe[0],
    hobbies: [frodoBio.hobbies[0], frodoBio.hobbies[1], frodoBio.hobbies[2], frodoBio.hobbies[3], frodoBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Pretty standard... nothing really stands out as great or not great`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'This is good! Let them know you prefer the idle life to the adventure you encountered',
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Nobody is going to get this, and it sounds very intense — too intense for a hobbit`,
        verdict: 'No', 
      },
      {
        feedback: `This is good to show that even though I'm adventurous I like to idle about`,
        verdict: 'Yes', 
      },
      {
        feedback: `It's OK`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Frodo is handsome and looks to be a gentleman, and he's quite adventurous, especially for a hobbit`,
    good: `You're very handsome and seem like a gentleman`,
    notGood: `The adventurousness and intensity. Remember, you're trying to attract hobbits, who prefer idleness`,
    verdict: `Overall it's a good start. Just add a bit more levity to your profile, and someone as handsome as you are will be swimming in matches`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...gatsbyReviewerReviewTinder },
  reviewerProfile: { ...gatsbyReviewerProfile },
  bioItems: { ...frodoBio },
  mediaItems: [ ...frodoMediaArray ],
}